import { Component, Input, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MovieModel } from 'src/app/core/interfaces/movie.model';

@Component({
  selector: 'app-ui-slides-card-carousel',
  templateUrl: './ui-slides-card-carousel.component.html',
  styleUrls: ['./ui-slides-card-carousel.component.scss']
})
export class UiSlidesCardCarouselComponent implements OnInit {

  @Input() movies: MovieModel[] = [];
  @Input() title: string;
  @Input() swiperConfig: SwiperConfigInterface;
  @Input() noBorders: boolean = false;
  swiperIndex = 0;


  constructor() {
    this.swiperConfig = {
      slidesPerView: 2,
      spaceBetween: -10,
      navigation: true,
      breakpoints: {
        480: { slidesPerView: 3 },
        700: { slidesPerView: 4 },
        1000: { slidesPerView: 6 },
        1600: { slidesPerView: 8 }
      }
    }
  }

  ngOnInit(): void {
  }

}
